<template>
    <header class="page-title">
        <slot></slot>
    </header>
</template>

<script>
import '@/assets/svg/search.svg?sprite';

export default {
    name: 'ui-title',
}

</script>

<style lang="scss">
    .page-title {
        padding: var(--padding) 0 0;
        margin: 0 var(--padding) var(--padding-x2);
        position: relative;

        h2 {
            font-size: var(--title-size);
            color: var(--font-color);
            text-align: center;
            text-transform: uppercase;
            padding: 0 5rem;
        }

        h3 {
            max-width: var(--page-width);
            padding:  0 var(--margin) 0;
            text-align: center;
            font-size: var(--title-size);
        }

        .ico-search {
            position: absolute;
            cursor: pointer;
            right: 0;
            top: var(--padding);
            height: 3.2rem;
            width: 3.2rem;

            svg {
                display: block;
                height: 100%;
                width: 100%;
                fill: var(--black);
                margin: 1rem 0 0;
            }
        }

    }

    @media only screen and (max-width: 767px) {
        .page-title {
            margin: 0 var(--padding) 0;

            h2,h3 {
                text-align: left;
                padding: 0;
            }


            .ico-search {
                top: var(--padding);
                height: 8rem;
                width: 8rem;

                svg {
                    margin: 1.2rem 0 0;
                }
            }

        }
        .page-inner {
            .page-title {
                margin: 0;
            }
        }

    }


</style>
